import { render } from "./right-bar.vue?vue&type=template&id=1363c314"
import script from "./right-bar.vue?vue&type=script&lang=js"
export * from "./right-bar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__